import { render } from "./Tree.vue?vue&type=template&id=1d168498"
import script from "./Tree.js?vue&type=script&lang=js"
export * from "./Tree.js?vue&type=script&lang=js"

import "./Tree.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__